// Things related to Downloads page
const Downloads = {
	fillTable: async () => 
		CP.getEntriesAndFillTable(
			CP.getel('DownloadsTableBody'),
			entry => (entry.entryValue.File?.ArkioExport != null || entry.entryValue.File?.ArkioPhotoExport != null), null,
			(tableBod, tableDat) => CP.fillTableWithEntries(tableBod, tableDat,
				{ enableDownload : true }, {onErr : CP.showErrorMessage, onWarn : CP.showWarningMessage})),
	bodyOnLoad: async () => {
		//TODO maybe do more things in DOMContentLoaded
		CP.initMsgManager(CP.getel('errorArea'), null, null);
		await CP.initPage();
		Downloads.fillTable();

		// How to get issues tab link and disable it
		// Get the Issues tab link
		//const issuesLink = getElements("navlist", "#issuesListItem > a")[0];
		//console.log("Issues tab link:", issuesLink);
		
		// Disable the Issues tab link
		//setNavigationLinkState(issuesLink, false);
	}
};
